/** @import { IEnvParams } from '@/types/definitions' */

const toBool = (val) => val === true || val === 'true';

/**
 * Use env parameters from the Server.
 *
 * @returns {IEnvParams} - static object with env params.
 */
export default function useEnvParams() {
  const config = useRuntimeConfig();
  return {
    brand: import.meta.env.VITE_ENTRY_POINT,
    isBcom: import.meta.env.VITE_ENTRY_POINT === 'bcom',
    isMcom: import.meta.env.VITE_ENTRY_POINT === 'mcom',
    assetHost: import.meta.env.VITE_ASSET_HOST,
    proxyProsHost: import.meta.env.VITE_PROXY_PROS_HOST,
    tagMngrEnabled: config.public.tagMngrEnabled,
    tagMngrAccount: config.public.tagMngrAccount,
    tagMngrEnv: config.public.tagMngrEnv,
    tealiumSyncEnabled: config.public.tealiumSyncEnabled,
    isClientSideCall: config.public.isClientSideCall,
    isEmbeddedStarMoneyEnabled: toBool(config.public.isEmbeddedStarMoneyEnabled),
    isFullProductCountEnabled: config.public.isFullProductCountEnabled,
    isCompareFeatureEnabled: toBool(config.public.isCompareFeatureEnabled),
    isStickyFiltersV3Enabled: toBool(config.public.isStickyFiltersV3Enabled),
    isMewFilterNameHideEnabled: config.public.isMewFilterNameHideEnabled,
  };
}
